import { jsx as _jsx } from "react/jsx-runtime";
import { startTransition, useContext, useEffect, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataHubService } from 'src/core/services/datahub';
import { ClickContentListSelectAllSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentListSelectAllSchema';
import { SelectedContentContext } from 'src/modules/contentList/contexts/selectedContentContext';
import { Checkbox } from 'src/shared/components/form/checkbox';
export function SelectAll() {
    const id = useId();
    const { t } = useTranslation();
    const { selectAll, allIsSelected } = useContext(SelectedContentContext);
    const [isSelected, setIsSelected] = useState(false);
    useEffect(function updateIsSelected() {
        setIsSelected(allIsSelected);
    }, [allIsSelected]);
    function handleSelect(event) {
        const { checked } = event.target;
        setIsSelected(checked);
        startTransition(() => {
            selectAll(checked);
        });
        DataHubService.sendEvent({
            schema: new ClickContentListSelectAllSchema({ actionType: checked ? 'SELECT' : 'UNSELECT' })
        });
    }
    return (_jsx("div", { className: "w-fit", children: _jsx(Checkbox, { id: id, checked: isSelected, onChange: handleSelect, label: t('content_list.tools.select_all'), labelClassName: "select-none" }) }));
}
